<template>
  <section class="high-efficency-nearby">
    <div class="high-efficency-nearby-sticky">
      <div class="nearby-phone-container">
        <div class="nearby-phone-left">
          <div ref="animationbg1" class="nearby-phone-bg"></div>
          <div ref="phone1" class="nearby-phone-box">
            <img v-lazy="require('../../assets/highEfficiency/share.jpg')" alt="ColorOS 11" class="nearby-phone-img" />
            <!-- <lazy-component ref="video1" class="nearby-phone-img nearby-phone-video">
              <video muted :src="require('../../assets/highEfficiency/nearby-share.mp4')" />
            </lazy-component> -->
          </div>
        </div>
        <div class="nearby-phone-right">
          <div ref="animationbg2" class="nearby-phone-bg"></div>
          <div ref="phone2" class="nearby-phone-box">
            <img
              v-lazy="require('../../assets/highEfficiency/receive.jpg')"
              alt="ColorOS 11"
              class="nearby-phone-img"
            />
            <!-- <lazy-component ref="video2" class="nearby-phone-img nearby-phone-video">
              <video muted :src="require('../../assets/highEfficiency/nearby-receive.mp4')" />
            </lazy-component> -->
          </div>
        </div>
      </div>
      <div v-textMotion="300" class="nearby-text-intro">
        <p class="title">{{ $t('nearby-title') }}</p>
        <p class="sub-title">{{ $t('nearby-sub-title') }}</p>
        <p class="description">{{ $t('nearby-description') }}<sup>3</sup></p>
      </div>
    </div>
  </section>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie_svg.min';
import aniDataScreen from './js/data.json';
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';
export default {
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      progress: 0,
      ifMobie: false,
      phonebg1: undefined,
      phonebg2: undefined
    };
  },
  computed: {},
  mounted() {
    if (window.innerWidth < 734) {
      this.ifMobie = true;
    }
    this.phonebg1 = lottie.loadAnimation({
      container: this.$refs.animationbg1,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: aniDataScreen
    });
    this.phonebg2 = lottie.loadAnimation({
      container: this.$refs.animationbg2,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: aniDataScreen
    });
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: 1.5 * window.innerHeight,
        triggerElement: '.high-efficency-nearby',
        triggerHook: 0
      })
        .setPin('.high-efficency-nearby-sticky')
        .addTo(Controller)
        .on('progress', e => {
          this.updateBezier('progress', e.progress, 300);
          if (this.progress > 0 && this.progress < 1 && this.$refs.phone1 && this.$refs.phone1.classList.length < 2) {
            this.$refs.phone1.classList.add('img-active');
            this.phonebg1.play();
            // setTimeout(() => {
            //   if (!this.$refs.video1.$el) return;
            //   this.$refs.video1.$el.children[0].currentTime = 0;
            //   this.$refs.video1.$el.children[0].play();
            // }, 1000);
            setTimeout(() => {
              this.$refs.phone2.classList.add('img-active');
              // setTimeout(() => {
              //   if (!this.$refs.video2.$el) return;
              //   this.$refs.video2.$el.children[0].currentTime = 0;
              //   this.$refs.video2.$el.children[0].play();
              // }, 1000);
              this.phonebg2.play();
            }, 500);
          }
          if (
            (this.progress === 0 || this.progress === 1) &&
            this.scene &&
            this.$refs.phone1 &&
            this.$refs.phone1.classList.length > 1
          ) {
            this.scene.destroy(true);
            this.scene = null;
          }
        });
      this.scene.progress(1);
    },
    resizeHandler() {
      if (window.innerWidth < 734) {
        this.progress = 2;
        if (this.scene) {
          this.scene.destroy(true);
          this.scene = null;
        }
      } else if (window.innerWidth >= 734 && !this.scene) {
        this.initScroll();
      }
      // 防止高度变化导致的裁切问题
      if (this.scene) this.scene.duration(0.5 * window.innerHeight);
    }
  }
};
</script>
<style lang="scss" scoped>
.high-efficency-nearby {
  .high-efficency-nearby-sticky {
    height: 150vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
  .nearby-text-intro {
    max-width: 588px;
    margin-top: 100px;
    .title {
      font-weight: 500;
    }
    .sub-title {
      font-size: 36px;
    }
  }
  .nearby-phone-container {
    height: 82vh;
    max-height: 785px;
    display: flex;
    justify-content: center;
    .nearby-phone-left,
    .nearby-phone-right {
      height: 100%;
      width: 70vh;
      max-width: 672px;
      position: relative;
      .nearby-phone-box {
        height: 100%;
        transform: translateY(15%);
        opacity: 0;
        transition: 0.7s;
      }
      .nearby-phone-img {
        height: 100%;
        overflow: hidden;
      }
      .nearby-phone-video {
        height: 96.5%;
        position: relative;
        top: -98.4%;
        border-radius: 10px;
        z-index: -1;
        font-size: 0;
        video {
          height: 100%;
          border-radius: 10px;
        }
      }
      .img-active {
        transform: translateY(0);
        opacity: 1;
      }
      .nearby-phone-bg {
        width: 100%;
        position: absolute;
        left: 0;
        top: 8.6%;
        z-index: -1;
      }
    }
    .nearby-phone-left {
      margin-right: 19px;
    }
  }
}
@media screen and (max-width: 1440px) {
  .high-efficency-nearby {
    .nearby-phone-container {
      height: 75vh;
      .nearby-phone-left,
      .nearby-phone-right {
        width: 35vw;
      }
    }
  }
}
@media screen and (max-width: 1200px) and (min-height: 630px) {
  .high-efficency-nearby {
    .nearby-phone-container {
      .nearby-phone-left,
      .nearby-phone-right {
        width: 45vw;
      }
    }
  }
}
@media screen and (max-width: 900px) {
  .high-efficency-nearby {
    .nearby-phone-container {
      height: 60vh;
    }
  }
}
@media screen and (max-width: 734px) {
  .high-efficency-nearby {
    display: none;
  }
}
</style>
